import { useQuery } from "@tanstack/react-query";
import { useAuth } from "../../../Context/AuthContext";
import { getRCSProcessingMessages } from "../api/RCSDashboardApi";

export const useRCSProcessingMessages = () => {
  const auth = useAuth();
  const user = auth.getSessionData();

  return useQuery({
    queryKey: ["RCSProcessingMessages"],
    queryFn: async () => {
      return await getRCSProcessingMessages({ token: user.token });
    },
    initialData: [],
    refetchOnWindowFocus: false,
  });
};
